import React from 'react';

import {
  Colors,
  // Dropdown,
  IconButton,
  Icons,
  // ListItem,
  Typography,
  createClasses,
} from '@kp/react-ui';

import { ChatModel } from './types';

const classes = createClasses({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 12px 12px 16px',
    borderBottom: `1px solid ${Colors.Neutral.border}`,
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  avatar: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: Colors.Selected.backgroundStrong,
  },
});

// const MODEL_OPTIONS = Object.values(ChatModel);

interface ChatHeaderProps {
  onClose: () => void;
  model: ChatModel;
  onModelChange: (model: ChatModel) => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({
  onClose,
  // TODO: model picker hidden for now — re-enable once model selection is supported.
  // model,
  // onModelChange,
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.titleSection}>
        <img
          src="/assets/images/ai-chat-avatar.svg"
          alt=""
          className={classes.avatar}
        />
        {/* TODO: model picker hidden for now — re-enable once model selection is supported.
        <Dropdown
          variant="tertiary"
          value={model}
          onChange={(value) => onModelChange(value as ChatModel)}
        >
          {MODEL_OPTIONS.map((chatModel) => (
            <ListItem key={chatModel} title={chatModel} value={chatModel} />
          ))}
        </Dropdown> */}
        <Typography variant="titleMedium">{ChatModel.KpAssistant}</Typography>
      </div>
      <IconButton
        icon={Icons.IconClear}
        onClick={onClose}
        data-testid="chat-header-close"
      />
    </div>
  );
};
